import React from "react";

const CdrPagination = ({ pagination, setPagination }) => {
  const { page, size, total } = pagination;

  const totalPages = Math.ceil(total / size);
  const start = (page - 1) * size + 1;
  const end = Math.min(page * size, total);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPagination((prev) => ({ ...prev, page: newPage }));
    }
  };

  const handleSizeChange = (newSize) => {
    setPagination((prev) => ({ ...prev, size: newSize, page: 1 })); // Reset to page 1 when size changes
  };

  return (
    <div className="flex flex-wrap justify-between items-center gap-4 py-2">
      {/* Showing range and total */}
      <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
        {total > 0
          ? `Showing ${start}-${end} of ${total} calls`
          : "No data available"}
      </p>

      {/* Page navigation */}
      <div className="flex items-center gap-2">
        {/* Previous Button */}
        <button
          onClick={() => handlePageChange(page - 1)}
          className="w-8 h-8 flex justify-center items-center rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 shadow-md disabled:opacity-50"
          disabled={page === 1}
          aria-label="Previous Page"
        >
          ◀
        </button>

        {/* Page Info */}
        <span className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
          {page} / {totalPages}
        </span>

        {/* Next Button */}
        <button
          onClick={() => handlePageChange(page + 1)}
          className="w-8 h-8 flex justify-center items-center rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 shadow-md disabled:opacity-50"
          disabled={page >= totalPages}
          aria-label="Next Page"
        >
          ▶
        </button>
      </div>

      {/* Items per page */}
      <div className="flex gap-2 text-sm text-text-secondary-light dark:text-text-secondary-dark  items-center">
        Items per page
        <select
          id="itemsPerPage"
          value={size}
          onChange={(e) => handleSizeChange(Number(e.target.value))}
          className="px-2 py-1 border border-gray-300 dark:border-gray-700 rounded-md bg-panel-light dark:bg-panel-dark text-sm text-gray-700 dark:text-gray-300 shadow-md"
          aria-label="Items per page"
        >
          {[15, 30, 50, 100].map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CdrPagination;
